define.alias("@embroider/util/services/ensure-registered", "auth/services/-ensure-registered");